import apiPaths from '../api-paths';

export default {
  list({ query = '' }) {
    return axios.get(`${ apiPaths.BOOKKEEPING }/declaration-types/${ query }`);
  },
};
